import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {LogSFTPComponent} from "./list-logSFTP.component";
import {MomentModule} from "angular2-moment";
import {NgStringPipesModule} from "pipes/string/index";
import {ScrollEventModule} from 'ngx-scroll-event';
import {BsDatepickerModule, defineLocale} from 'ngx-bootstrap';
import {esLocale} from 'ngx-bootstrap/locale';
import {BrowserAnimationsModule, NoopAnimationsModule} from "@angular/platform-browser/animations";
import {IonRangeSliderModule} from "ng2-ion-range-slider";
import {MaterialModule} from "../../../../material.module";
import {LoadingModule} from "../../../../autenticacion/loadingScreen/loading.module";

defineLocale('es', esLocale);

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        BrowserAnimationsModule,
        NoopAnimationsModule,
        BsDatepickerModule.forRoot(),
        MomentModule,
        NgStringPipesModule,
        IonRangeSliderModule,
        ScrollEventModule,
        MaterialModule,
        LoadingModule
    ],
    declarations: [LogSFTPComponent]
})
export class ListLogSFTPModule {
}




// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/transaccion/logSFTP/list-logSFTP.module.ts